// used to identify which route is needed for navigation - based on journeyId
const getJourneyRoute = (journeyId) => {
  let lowercaseJourneyId = journeyId.toLowerCase();

  // handle multiple saml inbound journeys; expect the journey id to always have 'samlinbound' in it.
  // if present, update journey id to 'avsamlinbound' for routing.
  if (lowercaseJourneyId.indexOf('samlinbound') >= 0) {
    lowercaseJourneyId = 'avsamlinbound';
  }

  let output;
  switch (lowercaseJourneyId) {
    case 'avlogin': {
      output = 'login';
      break;
    }
    case 'avlogout':
    case 'logout': {
      output = 'logout';
      break;
    }
    case 'avmfa': {
      output = '2fa-challenge';
      break;
    }
    case 'avmfaenrollment': {
      output = '2fa-enrollment';
      break;
    }
    case 'mfaenrollment-v5': {
      output = '2fa-enrollment-v2';
      break;
    }
    case 'avuserregistration': {
      output = 'sign-up';
      break;
    }
    case 'avforgottenpassword': {
      output = 'forgot-password';
      break;
    }
    case 'avforgottenusername': {
      output = 'forgot-userid';
      break;
    }
    case 'avkbamanage': {
      output = 'security-questions';
      break;
    }
    case 'avemailverification': {
      output = 'email-verification';
      break;
    }
    case 'avupdatepassword': {
      output = 'update-password';
      break;
    }
    case 'avmfamanage': {
      output = '2fa-management';
      break;
    }
    case 'aveproaccountlinking': {
      output = 'epro-account-linking';
      break;
    }
    case 'avsamlinbound': {
      output = 'saml-inbound';
      break;
    }
    default: {
      output = 'login';
    }
  }

  return output;
};

export default getJourneyRoute;
